/* ez-reviews.js — page-specific behaviour for /pages/reviews (loaded only when
   template.suffix == 'reviews', see layout/theme.liquid). Kept OUT of the shared
   sections/ez-pill-nav.liquid + sections/ez-review-showcase.liquid so it can't
   collide with concurrent edits to those shared sections or affect other pages.

   Wires the sticky filter bar (ez-pill-nav, sticky-bar variant) to the review
   cards: clicking a product-line pill (or a card's "{line} →" link) sets it
   active AND shows only that line's photo tiles (photo-mosaic) + text rows
   (photo-stacked), and keeps the "N verified · showing M" counter honest.
   Category is read from what the cards already render in the DOM
   (.ez-rvw__pw-cat / .ez-rvw__ps-row-catlink), so no shared markup change needed.
   State lives in the URL hash (#rv-shades) so it deep-links + back/forward work.
   Fully defensive: any missing element just no-ops that part. */
(function () {
  'use strict';

  function text(n) { return n ? (n.textContent || '') : ''; }
  // Normalise a label/category: drop "·", "→", "(...)" decorations, collapse
  // whitespace, lowercase — so pill "RV Shades" == card " · RV Shades".
  function norm(s) { return (s || '').replace(/[()·→★]/g, '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  var bar = document.querySelector('.ez-pn--sticky-bar');
  if (!bar) return;
  var pills = Array.prototype.slice.call(bar.querySelectorAll('.ez-pn__pill'));
  if (!pills.length) return;

  // Card index: mosaic photo tiles + stacked text rows, each tagged with its
  // normalised category and the review section it lives in.
  var cards = [];
  var psRows = [];
  Array.prototype.forEach.call(document.querySelectorAll('.ez-rvw__pw-tile'), function (el) {
    cards.push({ el: el, cat: norm(text(el.querySelector('.ez-rvw__pw-cat'))), sec: el.closest('.shopify-section') });
  });
  Array.prototype.forEach.call(document.querySelectorAll('.ez-rvw__ps-row'), function (el) {
    var c = { el: el, cat: norm(text(el.querySelector('.ez-rvw__ps-row-catlink'))), sec: el.closest('.shopify-section') };
    cards.push(c); psRows.push(c);
  });
  if (!cards.length) return;

  var sections = [];
  cards.forEach(function (c) { if (c.sec && sections.indexOf(c.sec) === -1) sections.push(c.sec); });
  var countMeta = document.querySelector('.ez-rvw__ps-header-count');
  var countMetaAll = countMeta ? countMeta.textContent : '';

  function labelOf(pill) { return norm(text(pill.querySelector('.ez-pn__pill-label'))); }
  function pillByLabel(lbl) { for (var i = 0; i < pills.length; i++) { if (labelOf(pills[i]) === lbl) return pills[i]; } return null; }

  function activate(pill) {
    var target = labelOf(pill);
    var isAll = !target || target === 'all';

    cards.forEach(function (c) { c.el.style.display = (isAll || c.cat === target) ? '' : 'none'; });

    // Collapse a review section that now has no visible cards (e.g. the photo
    // mosaic for a line with no photos) so no empty header is left hanging.
    sections.forEach(function (sec) {
      var anyVisible = cards.some(function (c) { return c.sec === sec && c.el.style.display !== 'none'; });
      sec.style.display = anyVisible ? '' : 'none';
    });

    pills.forEach(function (p) { p.classList.remove('is-active'); p.removeAttribute('aria-current'); });
    pill.classList.add('is-active');
    pill.setAttribute('aria-current', 'true');

    if (countMeta) {
      if (isAll) {
        countMeta.textContent = countMetaAll;
      } else {
        var shown = psRows.filter(function (c) { return c.el.style.display !== 'none'; }).length;
        var pillCount = text(pill.querySelector('.ez-pn__pill-count')).replace(/[()]/g, '').trim();
        countMeta.textContent = (pillCount ? pillCount + ' verified · ' : '') + 'showing ' + shown;
      }
    }
  }

  // Apply whatever the URL hash asks for (empty hash → the "All" pill).
  function fromHash() {
    var h = norm((location.hash || '').replace('#', '').replace(/-/g, ' '));
    var pill = (h && h !== 'all') ? pillByLabel(h) : pillByLabel('all');
    if (pill) activate(pill);
  }

  // Pills filter directly + record the hash silently (replaceState, so no extra
  // hashchange). Card "{line} →" links are real hash navigations, handled below.
  pills.forEach(function (pill) {
    pill.addEventListener('click', function (e) {
      e.preventDefault();
      activate(pill);
      try {
        var t = labelOf(pill);
        if (t && t !== 'all') { history.replaceState(null, '', '#' + t.replace(/\s+/g, '-')); }
        else { history.replaceState(null, '', location.pathname + location.search); }
      } catch (err) { /* history unavailable — filtering still works */ }
    });
  });

  window.addEventListener('hashchange', fromHash);

  // Deep link on load: /pages/reviews#rv-shades applies that filter.
  if ((location.hash || '').replace('#', '')) fromHash();
})();

// Release the sticky filter bar once the reviews list has scrolled past, so it stops floating over the
// later sections (video / CTA / footer). It stays sticky while the reviews are in view.
(function () {
  var bar = document.querySelector('.ez-section--pill-nav');
  if (!bar) return;
  var rvw = document.querySelectorAll('[class*="ez-rvw"]');
  var last = rvw.length ? rvw[rvw.length - 1].closest('[id^="shopify-section"]') : null;
  if (!last) return;
  function update() {
    var top = window.innerWidth <= 900 ? 62 : 72;
    bar.style.position = last.getBoundingClientRect().bottom <= top ? 'static' : '';
  }
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();
